var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwitch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Switch") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-79.000000, -113.000000)",
    stroke: "#444444"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Switch",
    transform: "translate(80.347660, 114.347660)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "4.92187 9.84374 2.46093 12.30464 -8.8817842e-16 9.84374"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.46093,
    y1: -8.8817842e-16,
    x2: 2.46093,
    y2: 12.30464,
    id: "Path"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "7.38284 2.46093 9.84374 -8.8817842e-16 12.30464 2.46093"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.84374,
    y1: 12.30464,
    x2: 9.84374,
    y2: -8.8817842e-16,
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch);
export default __webpack_public_path__ + "static/media/Switch.6eb63dc9.svg";
export { ForwardRef as ReactComponent };